export default "__VITE_ASSET__C3oDgZMV__"